import bwipjs from "bwip-js";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export function barcodeDataUrl(text, { jpeg = false, scale = 4, height = 16 } = {}) {
  const canvas = document.createElement("canvas");
  bwipjs.toCanvas(canvas, { bcid: "code128", text: String(text).trim(), scale, height, inkspread: 0.1, includetext: true, textxalign: "center", textsize: 11, backgroundcolor: "FFFFFF", paddingwidth: 6, paddingheight: 4 });
  return canvas.toDataURL(jpeg ? "image/jpeg" : "image/png", 0.95);
}

const money = (v) => (v ? `Rp ${Number(v).toLocaleString("id-ID")}` : "");

function fit(ctx, text, max) {
  let t = String(text ?? "");
  while (t.length > 4 && ctx.measureText(t).width > max) t = t.slice(0, -1);
  return t === String(text ?? "") ? t : t.slice(0, -1) + "…";
}

// Compose a full label as one image: Name + barcode + SKU · Harga.
export function labelImageDataUrl(item, { jpeg = false } = {}) {
  const bc = document.createElement("canvas");
  bwipjs.toCanvas(bc, { bcid: "code128", text: String(item.sku).trim(), scale: 4, height: 16, inkspread: 0.1, includetext: true, textxalign: "center", textsize: 11, backgroundcolor: "FFFFFF", paddingwidth: 4, paddingheight: 2 });
  const W = 620, H = 340;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#FFFFFF"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#000000"; ctx.textAlign = "center"; ctx.textBaseline = "alphabetic";
  ctx.font = "bold 34px Arial";
  ctx.fillText(fit(ctx, item.name || "", W - 40), W / 2, 48);
  const maxBW = W - 60, maxBH = 170;
  const sc = Math.min(maxBW / bc.width, maxBH / bc.height);
  const dw = bc.width * sc, dh = bc.height * sc;
  ctx.drawImage(bc, (W - dw) / 2, 74, dw, dh);
  const price = money(item.price);
  ctx.fillStyle = "#000000"; ctx.font = "bold 30px Arial";
  ctx.fillText(`${item.sku}${price ? "   ·   " + price : ""}`, W / 2, 74 + dh + 42);
  return c.toDataURL(jpeg ? "image/jpeg" : "image/png", 0.95);
}

export function downloadBarcodeJpg(item, filename) {
  const it = typeof item === "string" ? { sku: item, name: item } : item;
  const url = labelImageDataUrl(it, { jpeg: true });
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(filename || it.name || it.sku).toString().replace(/[^\w.-]+/g, "_")}.jpg`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

function labelSheetHtml(items, mode) {
  const labels = items
    .map((it) => {
      const img = barcodeDataUrl(it.sku, { scale: 4, height: mode === "thermal" ? 11 : 15 });
      const price = money(it.price);
      return `<div class="lbl"><div class="nm">${esc(it.name)}</div><img src="${img}"/><div class="meta">${esc(it.sku)}${price ? " · " + price : ""}</div></div>`;
    })
    .join("");
  const css =
    mode === "thermal"
      ? `@page{size:33mm 15mm;margin:0}body{margin:0}.lbl{width:33mm;height:15mm;box-sizing:border-box;padding:0.6mm 1mm;page-break-after:always;text-align:center;overflow:hidden;font-family:Arial;display:flex;flex-direction:column;justify-content:center}.lbl .nm{font-size:6pt;font-weight:bold;line-height:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#000}.lbl img{height:7mm;width:31mm;object-fit:contain}.lbl .meta{font-size:5.5pt;line-height:1;font-weight:bold;color:#000}`
      : `@page{size:A4;margin:8mm}body{margin:0}.sheet{display:flex;flex-wrap:wrap;gap:3mm}.lbl{width:45mm;height:26mm;box-sizing:border-box;border:1px dashed #bbb;border-radius:2mm;padding:1mm;text-align:center;overflow:hidden;font-family:Arial;display:flex;flex-direction:column;justify-content:center}.lbl .nm{font-size:8pt;font-weight:bold;line-height:1.1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#000}.lbl img{height:11mm;width:43mm;object-fit:contain;margin:0.5mm 0}.lbl .meta{font-size:7pt;font-weight:bold;color:#000}`;
  const body = mode === "thermal" ? labels : `<div class="sheet">${labels}</div>`;
  return `<html><head><meta charset="utf-8"><title>Cetak Barcode</title><style>${css}</style></head><body onload="window.focus();setTimeout(function(){window.print();},250)">${body}</body></html>`;
}

export function printLabels(items, mode = "a4") {
  const valid = (items || []).filter((i) => i.sku && String(i.sku).trim());
  if (!valid.length) return 0;
  const w = window.open("", "_blank");
  if (!w) return -1;
  w.document.write(labelSheetHtml(valid, mode));
  w.document.close();
  return valid.length;
}
